var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "breadcrumbs" }, [
    _c(
      "div",
      { staticClass: "breadcrumbs-links" },
      _vm._l(_vm.links, function (link, index) {
        return _c(
          "a",
          { key: index, on: { click: link.onClick } },
          [
            _c(
              "paragraph",
              {
                staticClass: "breadcrumbs-link",
                class: {
                  "default-text":
                    !_vm.isTheLastLink(index) || !_vm.moreThanOneLink,
                  "highlight-text":
                    _vm.isTheLastLink(index) && _vm.moreThanOneLink,
                },
                attrs: { type: "p", variation: "button-medium" },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(link.text) +
                    " " +
                    _vm._s(_vm.isTheLastLink(index) ? "" : " /") +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }